<div class="bg-preview w-full md:h-9 text-center content-center">
  <p class="text-white">
    {{
    (previewMode === PreviewMode.FreeFlow
    ? "preview.label.headerrulesoff"
    : "preview.label.headerruleson"
    ) | translate
    }}
  </p>
</div>